"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactPlugin = void 0;
const react_1 = require("react");
const addFn = (setters, field, fn) => {
    if (!setters[field])
        setters[field] = [];
    setters[field].push(fn);
};
const removeFn = (collection, fn) => {
    for (let i = collection.length - 1; i >= 0; --i) {
        if (collection[i] === fn) {
            collection.splice(i, 1);
        }
    }
};
const reactPlugin = (lead) => {
    const stateSetters = {};
    lead.useField = (field) => {
        const [fieldState, setFieldState] = (0, react_1.useState)(() => (lead.fields.get(field)));
        const updateField = (0, react_1.useCallback)((value) => {
            lead.fields.set(field, value);
        }, [field]);
        (0, react_1.useEffect)(() => {
            addFn(stateSetters, field, setFieldState);
            return () => {
                removeFn(stateSetters[field], setFieldState);
            };
        }, [setFieldState, field]);
        return [fieldState, updateField];
    };
    return {
        onFieldUpdate: (key, newValue) => {
            if (stateSetters[key]) {
                stateSetters[key].forEach((cb) => {
                    cb(newValue);
                });
            }
            return newValue;
        },
    };
};
exports.reactPlugin = reactPlugin;
//# sourceMappingURL=react.js.map